export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const id = config.public.gaMeasurementId;
  const { loggedUser } = useAuthStore();

  /**
   * Safe gtag function that pushes to dataLayer if on client.
   * Guaranteed to exist even if analytics script fails to load.
   */
  const gtag = (...args) => {
    if (import.meta.client) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(args);
    }
  };

  if (import.meta.client) {
    // 1. Basic GTAG Init
    window.dataLayer = window.dataLayer || [];
    gtag('js', new Date());

    if (id) {
      gtag('config', id);

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(script);
    }

    // 2. Global Error Tracking (Replicated from legacy)

    // JS Errors
    window.onerror = function (message, source, lineno, colno, err) {
      gtag("event", "js_error", {
        event_category: "Error",
        event_label: "JS Error",
        event_value: `${message} at ${source}:${lineno}:${colno}`,
        app_user_id: loggedUser?.id,
        non_interaction: true,
      });
      return false;
    };

    // Unhandled Promises (API errors etc)
    window.onunhandledrejection = function (event) {
      if (event.reason?.data?.isFromCancel) return;

      let reason = "";
      if (event.reason?.data) reason = event.reason.data.msg;
      else if (event.reason?.message) reason = event.reason.message;
      else reason = String(event.reason);

      gtag("event", "promise_error", {
        event_category: "Error",
        event_label: `Promise Error`,
        event_value: reason,
        app_user_id: loggedUser?.id,
        non_interaction: true,
      });
    };

    // Vue Errors
    nuxtApp.vueApp.config.errorHandler = function (err, vm, info) {
      // console.error('Vue Error:', err);
      gtag("event", "vue_error", {
        event_category: "Error",
        event_label: `Vue Error`,
        event_value: err.message,
        app_user_id: loggedUser?.id,
        non_interaction: true,
      });
    };
  }

  // Inject $gtag as a global helper
  return {
    provide: {
      gtag
    }
  };
});
